import * as React from "react";
import * as main from "../../main.module.scss";
import * as problems from "./style.module.scss";
export const Problems = () => {
  return (
    <section className={problems.problems}>
      <div className="container">
        <h2 className={main.title}>Если ваш ребёнок</h2>
        <ul>
          <li>только начинает учиться читать или делает это медленно;</li>
          <li>имеет сложности с чтением, запоминанием прочитанного и пройденного материала;</li>
          <li>не может сконцентрироваться на занятиях и при выполнении домашней работы;</li>
          <li>постоянно допускает ошибки из-за невнимательности;</li>
        </ul>
        <p>… мы настоятельно рекомендуем не откладывать и начать решать эти проблемы вместе с нами на курсе «Учись учиться. Начало»</p>
        <div className={problems.vid} style={{ display: "none" }}>
          <div className={problems.bg}>
            <iframe
              src={""}
              title={"Title"}
              allow={"autoplay; encrypted-media"}
              allowFullScreen
            />
          </div>
        </div>
        <p style={{ display: "none" }}>2-минутное видеознакомство с курсом «Учись учиться»</p>
      </div>
    </section>
  );
};
